import React from 'react';

function About() {
  return (
    <div>
      <h2>About Page</h2>
      <p>Learn more about our company or project.</p>
    </div>
  );
}

export default About;
